__turbopack_context__.v({
  "container": "_4yMXca_container",
  "heading": "_4yMXca_heading",
  "links": "_4yMXca_links",
});
